import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import store from '@/store';
import { TreeItem, TreeType } from '@/components/Layers/modal/types';
import { getCanvasElementIcon, getCanvasElementTitle } from '@/utils/elementsUtils';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';
import CCheckbox from '@/components/shared/CCheckbox.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalImportLayersTreeItem',
  props: {
    treeItem: null,
    marginLevel: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { treeItem: TreeItem, marginLevel: number };



const showChildren = ref(true);

const selected = computed({
    get() {
        return store.state.storeLayersModal!.selectedTreeItems.some((item) => {
            const hasUuid = [TreeType.CANVAS_ELEMENT, TreeType.PAGE_EPS, TreeType.HIDDEN].includes(item.type);
            return hasUuid ? item.uuid === props.treeItem.uuid : item.id === props.treeItem.id;
        });
    },
    set(value: boolean) {
        const methods: Record<string, (treeItem: TreeItem) => void> = {
            [TreeType.CANVAS_ELEMENT]: (treeItem) => {
                if (value) {
                    store.dispatch('storeLayersModal/addSelectedTreeItem', treeItem);
                } else {
                    store.dispatch('storeLayersModal/removeSelectedTreeItem', treeItem);
                }
            },
            default: (treeItem) => {
                methods[TreeType.CANVAS_ELEMENT](treeItem);
                treeItem.children?.forEach((item: TreeItem) => {
                    methods['default'](item);
                });
            }
        };

        (methods[props.treeItem.type] || methods['default'])(props.treeItem);
    }
});

const getIcon = computed(() => getCanvasElementIcon(undefined, props.treeItem.icon) || '');

const childrenLevel = computed(() => {
    const types: Record<string, number> = {
        '0': 1,
        '1': 2,
        '2': 3,
        ['default']: 0
    };
    return types[props.marginLevel] || types['default'];
});

const itemName = computed(() => {
    if (props.treeItem.name && props.treeItem.type !== TreeType.PAGE_EPS) {
        return props.treeItem.name;
    }

    return getCanvasElementTitle({ id: Number(props.treeItem.id) }, props.treeItem.icon);
});

const isType = (type: TreeType) => computed(() => props.treeItem.type === type);

const showTooltip = computed(() =>
    [TreeType.CANVAS_ELEMENT, TreeType.PAGE_EPS, TreeType.GROUP].includes(props.treeItem.type)
);

const isCanvasElement = isType(TreeType.CANVAS_ELEMENT);

const isSelectAll = isType(TreeType.SELECT_ALL);

const isHidden = isType(TreeType.HIDDEN);

const hasChildren = computed(() => props.treeItem.children?.length);

const handleTreeItem = () => {
    selected.value = !selected.value;
};

return { __sfc: true,props, showChildren, selected, getIcon, childrenLevel, itemName, isType, showTooltip, isCanvasElement, isSelectAll, isHidden, hasChildren, handleTreeItem, SvgIcon, CCheckbox }
}

})